export default __webpack_public_path__ + "static/media/Natwest.ff88c7e9.svg";